import {AsRoute} from "../../app";
import {Page} from "../page";
import {Card} from "../generic/card";
import {FormFooter, FormGroup} from "../generic/form";
import {Button} from "../generic/button";

export function LoginForm() {
    return <form action={`${location.href}${location.search}`} method="post" class="form-small text-left">
        <FormGroup>
            <label for="username">User name:</label>
            <input type="text" name="username" />
        </FormGroup>
        <FormGroup>
            <label for="password">Password:</label>
            <input type="password" name="password" />
        </FormGroup>
        <FormFooter>
            <Button type="submit">Log in</Button>
        </FormFooter>
    </form>
}

export function Login(props: AsRoute) {
    return <Page class="container" showBackButton={true}>
        <Card title="Log in" class="text-center block-vcenter">
            <LoginForm />
        </Card>
    </Page>
}
